// Source: http://www.sitepoint.com/article/standards-compliant-world/
function externalLinks() {
  if ( !document.getElementsByTagName ) return;
  // var anchors = document.getElementsByTagName("a, wa-button");
  var anchors = document.querySelectorAll("a, wa-button");
  for ( var i=0; i<anchors.length; i++ ) {
    var anchor = anchors[i];
    if ( anchor.getAttribute("href") && anchor.getAttribute("rel") == "external" )
      anchor.target = "_external";
  }
}
window.onload = externalLinks;

// Clear docsearch input field
function focusSearchBox() {
  let x = document.getElementById("docsearch");
  x.style.color = "black";
  x.value = "";
}

function blurSearchBox() {
  let x = document.getElementById("docsearch");
  x.style.color = "var(--wa-color-neutral-90)";
  x.value = "";
}

let el = document.getElementById("docsearch");
if ( el ) {
  el.addEventListener("focus", focusSearchBox, true);
  el.addEventListener("blur", blurSearchBox, true);
}
